export default __webpack_public_path__ + "static/media/body_organ_lung.6557fcb8.png";